import type { Catalogue } from './en.ts';

/**
 * Arabic — second-wave locale, present in this build to keep the RTL path
 * honest rather than theoretical. Layout mirrors fully; card order and the
 * discard pile do not (§10). Needs a native reviewer before release.
 */
export const ar: Catalogue = {
  'app.name': 'رمي',
  'app.tagline': 'طاولة لأصدقائك. بلا رهان، أبدًا.',

  'auth.heading': 'اجلس',
  'auth.or': 'أو',
  'auth.email.label': 'البريد الإلكتروني',
  'auth.password.label': 'كلمة المرور',
  'auth.signin': 'تسجيل الدخول',
  'auth.signup': 'إنشاء حساب',
  'auth.haveAccount': 'عضو بالفعل؟',
  'auth.newHere': 'جديد هنا؟',
  'auth.profile.heading': 'اختر أسلوبك',
  'auth.shuffle': 'بدّل',
  'auth.enter': 'ادخل النادي',
  'auth.error.invalid-credentials': 'البريد أو كلمة المرور غير صحيحة.',
  'auth.error.weak-password': 'استخدم 8 أحرف على الأقل.',
  'lobby.hey': 'أهلًا',
  'lobby.sub': 'مع من نلعب الليلة؟',
  'lobby.practice': 'تدريب',
  'lobby.practice.note': 'طاولة كاملة من الروبوتات بلمسة واحدة.',
  'lobby.joinByCode': 'لديك رمز؟',
  'settings.signout': 'تسجيل الخروج',
  'auth.guest': 'العب كضيف',
  'auth.retry': 'حاول مرة أخرى',
  'auth.name.label': 'بماذا تناديك الطاولة؟',
  'auth.name.placeholder': 'اسمك',
  'auth.adult': 'عمري 18 سنة أو أكثر',

  'lobby.heading': 'البهو',
  'lobby.friends': 'الأصدقاء',
  'lobby.friends.empty': 'العب على طاولة، وسيظهر من كان معك هنا.',
  'lobby.rooms': 'الغرف الأخيرة',
  'lobby.create': 'أنشئ غرفة',
  'lobby.join': 'انضم',
  'lobby.invite': 'ادعُ',

  'presence.online': 'متصل',
  'presence.at-table': 'في {room}',
  'presence.away': 'بعيد',
  'presence.offline': 'غير متصل',

  'room.heading': 'غرفة {id}',
  'room.format': 'الصيغة',
  'room.seats': 'المقاعد',
  'room.turnTimer': 'مؤقت الدور',
  'room.turnTimer.value': '{seconds, number} ثانية',
  'room.guard': 'حارس الإعلان',
  'room.invite': 'رابط الدعوة',
  'room.copy': 'انسخ',
  'room.copied': 'تم النسخ',
  'room.addBot': 'أضف خصم تدريب',
  'room.start': 'ابدأ الجلسة',
  'room.leave': 'غادر',
  'room.host': 'المضيف',
  'room.you': 'أنت',
  'room.decks': 'مقعدان يلعبان بمجموعة واحدة وجوكر واحد. ثلاثة أو أكثر يلعبون بمجموعتين.',

  'table.yourTurn': 'دورك',
  'table.turnOf': '{name} يفكر',
  'table.discard': 'ارمِ',
  'table.declare': 'أعلن',
  'table.drop': 'انسحب',
  'table.sort': 'رتّب',
  'table.undo': 'تراجع',
  'table.closed': 'الكومة المغلقة',
  'table.closed.count':
    '{count, plural, zero {لا أوراق} one {ورقة واحدة} two {ورقتان} few {# أوراق} many {# ورقة} other {# ورقة}} متبقية',
  'table.open': 'الكومة المفتوحة',
  'seat.cards': '{count, plural, zero {لا أوراق} one {ورقة واحدة} two {ورقتان} few {# أوراق} many {# ورقة} other {# ورقة}}',
  'points.short': '{points, number} نقطة',
  'table.wild': 'الجوكر البري',
  'table.points': 'إذا انتهت اليد الآن: {points, number}',
  'table.yourScore': 'مجموعك',
  'table.handOf': 'اليد {n, number}',
  'table.reconnecting': 'إعادة الاتصال',
  'table.leave': 'غادر الطاولة',

  'group.pure': 'تسلسل نقي',
  'group.impure': 'تسلسل',
  'group.set': 'مجموعة',
  'group.new': 'مجموعة جديدة',

  'declare.heading': 'الإعلان',
  'declare.confirm': 'أكّد الإعلان',
  'declare.cancel': 'رجوع',

  'summary.points': 'النقاط',
  'summary.total': 'المجموع',
  'summary.reentry': 'تجاوز 201 عند {from, number} · عاد عند {to, number}',
  'summary.continue': 'متابعة',
  'outcome.won': 'فاز',
  'outcome.lost': 'خسر',

  'session.heading': 'انتهت الجلسة',
  'session.rematch': 'مباراة أخرى',
  'session.leave': 'غادر',
  'session.details.show': 'عرض تفاصيل الجلسة',
  'session.details.hide': 'إغلاق تفاصيل الجلسة',
  'session.hands':
    '{n, plural, zero {# جولة} one {جولة واحدة} two {جولتان} few {# جولات} many {# جولة} other {# جولة}}',
  'session.hand': 'جولة',
  'session.margin': 'فاز بفارق {points, number}',
  'session.margin.none': 'تعادل في الصدارة',
  'session.celebrate': 'احتفل مرة أخرى',
  'session.you': 'أنت',
  'session.out': 'خارج',
  'session.outAt': 'خرج في الجولة {n, number}',
  'session.reentry': 'عاد عند {to, number} (الجولة {n, number})',
  'session.reentry.note':
    'العودة تعيد النتيجة إلى أعلى نتيجة ما زالت في اللعب، لذا قد يكون مجموع الجولات أكبر من المجموع الظاهر تحتها.',
  'session.tab.standings': 'الترتيب',
  'session.tab.progress': 'التقدّم',
  'session.tab.hands': 'الجولات',
  'session.stat.won': 'جولات فائزة',
  'session.stat.average': 'المعدل لكل جولة',
  'session.stat.best': 'أفضل جولة',
  'session.stat.drops': 'انسحابات',
  'session.award.wins': 'الأكثر فوزًا',
  'session.award.steady': 'الأكثر ثباتًا',
  'session.award.tight': 'الأقرب',
  'session.award.wins.value':
    '{n, plural, zero {# جولة} one {جولة} two {جولتان} few {# جولات} many {# جولة} other {# جولة}}',
  'session.award.points.value': '{points, number} نقطة',
  'session.chart.hand': 'بعد الجولة {n, number}',
  'session.chart.start': 'قبل الجولة الأولى',
  'session.chart.empty': 'لم تُلعب أي جولة.',

  'settings.heading': 'الإعدادات',
  'settings.language': 'اللغة',
  'settings.close': 'إغلاق',
};
